export default __webpack_public_path__ + "static/media/4691.4413d2c3.png";